/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ColorRing } from 'react-loader-spinner';
import Modal from 'react-responsive-modal';
import CustomErrorPopup from "../../../../components/CustomErrorPopup/CustomErrorPopup";
import S3UploadHook from "../../../../CommonMethods/S3UploadHook";
import BulkUpload from "./BulkUpload";
import { dataService } from "../../../../services/data.services";
import GlobalContext from "../../../../components/Context/GlobalContext";

export default function BulkStore() {

    const [importLoading, setImportLoading] = useState(false);
    const [modalpopup, setmodalpopup] = useState({});
    const [progressCount, setprogressCount] = useState();

    const { setToastmessage, setToastError } = useContext(GlobalContext);

    async function addStores(body, fileName) {
        try {
            const response = await dataService.PostAPI(body, `stores/upload`)
            if (response?.data?.message === 'Records created successfully') {
                setToastError('');
                setToastmessage('');
                setToastmessage('Stores uploaded successfully')
                setImportLoading(false);
            } else if (response?.data?.message === 'Partial records created') {
                const error_index = response?.data?.error_index
                setmodalpopup({
                    open: true,
                    error_index,
                    fileName
                });
                setImportLoading(false);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 400) {
                if (error?.response?.data?.message === 'Invalid column header') {
                    setToastError('');
                    setToastmessage('');
                    setToastError('Record header mismatch: (Please refer to the sample file)');
                } else {
                    setToastError('');
                    setToastmessage('');
                    setToastError(error?.response?.data?.message);
                }
                setImportLoading(false);
            }else {
                setToastError('An error occurred!');
                setImportLoading(false);
            }
            setImportLoading(false);
        }
    }

    return (
        <BulkUpload
            isLoading={importLoading}
            setIsLoading={setImportLoading}
            modalpopup={modalpopup}
            setmodalpopup={setmodalpopup}
            setprogressCount={setprogressCount}
            S3FilePrefix='bulk-store'
            sampleFileName='sample_store_format'
            addDetails={addStores} 
            bulkUploadFor='stores'
            invalidHeader='Invalid Store Details:'/>
    );
}
